import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=4066dad6&scoped=true&"
import script from "./approve.vue?vue&type=script&lang=ts&"
export * from "./approve.vue?vue&type=script&lang=ts&"
import style0 from "./approve.vue?vue&type=style&index=0&id=4066dad6&scoped=true&lang=css&"
import style1 from "./approve.vue?vue&type=style&index=1&id=4066dad6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066dad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VLayout,VTextarea})
